import { render, staticRenderFns } from "./TemplatePathChooser.vue?vue&type=template&id=3ec87999&scoped=true&"
import script from "./TemplatePathChooser.vue?vue&type=script&lang=js&"
export * from "./TemplatePathChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec87999",
  null
  
)

export default component.exports